import { getRequest } from '../services/requestHandler';
import { FedExCupPlayer } from '../models';

export const getFedExCupPlayers = async () => {
  const url = 'fedexcup/getplayers';
  const response = await getRequest<FedExCupPlayer>('GetFedExCupPlayers', url);
  return response;
};
